import useRootStore from './useRootStore';

export default function useSearchEvent() {
  const { searchEventStore } = useRootStore();
  return searchEventStore;
}
